import { render } from "./PageNav.vue?vue&type=template&id=b06ce2e2&scoped=true"
import script from "./PageNav.vue?vue&type=script&lang=js"
export * from "./PageNav.vue?vue&type=script&lang=js"

import "./PageNav.vue?vue&type=style&index=0&id=b06ce2e2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b06ce2e2"]])

export default __exports__